<template>
    <div class="layout-footer">
        <img v-bind:src="'/images/logo-hris-website.png'" style="height:32px;" alt="Logo"/>
    </div>
</template>

<script>
export default {
    name: "AppFooter",
}
</script>

<style scoped>

</style>
